import * as React from 'react'
import type { Models } from '@packages/survey-api'
import { createContext, useContextSelector } from 'use-context-selector'

export type Question = {
  id: string
  type: 'question'
  text: string
  role: string
  choices: Array<{ id: string; value: string }>
}

export type Message =
  | {
      id: string
      type: 'answer'
      text: string
    }
  | Question

export type SurveyOptions = Omit<Models['OpenSurveyParams'], 'id'>

export type Chat = Array<Message>

export type RequestsCtx = {
  surveyQueryFn: (args: {
    surveyId: string
    meta: SurveyOptions
    // in preview mode
    questionId?: string
  }) => Promise<
    Models['OpenSurveyResponse'] | Models['OpenSurveyPreviewResponse']
  >
  surveyRespondMutationFn: (
    params: Models['RespondSurveyParams']
  ) => Promise<
    Models['RespondSurveyResponse'] | Models['RespondPreviewResponse']
  >
}

const requestsCtx = createContext<RequestsCtx>(0 as any)

export const useRequest = <Selected,>(
  selector: (value: RequestsCtx) => Selected
) => useContextSelector(requestsCtx, selector)

const RequestCtx = ({
  children,
  ...props
}: React.PropsWithChildren<RequestsCtx>) => {
  return <requestsCtx.Provider value={props}>{children}</requestsCtx.Provider>
}

export default RequestCtx
